import { X } from 'lucide-react';
import './WindowControl.css';

/** Shared control for closing, resizing and preview window actions. */
export default function WindowControl({ children, size = 'default', className = '', title, 'aria-label': label, ...props }) {
  return <button {...props} type="button" data-window-control="true" data-control-size={size} className={className}
    title={title || label} aria-label={label || title || 'Schließen'}>{typeof children === 'string' && children.trim() === '×' ? <X /> : children}</button>;
}
